import React from "react";
import { Link } from "react-router-dom";
import TEXT from "../../../utils/text/publication.json";
import "./PublicationListItem.css";

export default function PublicationListItem({
  title,
  author,
  country,
  programArea,
  topics,
  status,
  description,
  code,
  language,
  imageFileName,
}) {
  function makeSentenceFromTopics(topics) {
    if (topics.length === 0) return "";
    let sentence;

    for (let i = 0; i < topics.length; i++) {
      if (i === 0) {
        sentence = topics[0];
      } else if (i === topics.length - 1) {
        sentence += " y " + topics[i];
      } else {
        sentence += ", " + topics[i];
      }
    }

    return sentence;
  }
  return (
    <div className="pli-container">
      <div className={"pli-text" + (imageFileName ? "" : " pli-text-noimage")}>
        <div className="pli-title">
          <Link to={"/publicacion/" + code}>{title}</Link>
        </div>
        <div className="pli-description">{description}</div>
        <div className="pli-information">
          <div>
            <strong className="pli-info-header">
              {TEXT["researcher"][language]}
            </strong>
            : {author}
          </div>
          <div>
            <strong className="pli-info-header">
              {TEXT["country"][language]}
            </strong>
            : {country}
          </div>
          <div>
            <strong className="pli-info-header">
              {TEXT["programArea"][language]}
            </strong>
            : {programArea}
          </div>
          <div>
            <strong className="pli-info-header">
              {TEXT["topics"][language]}
            </strong>
            : {makeSentenceFromTopics(topics)}
          </div>
          <div>
            <strong className="pli-info-header">
              {TEXT["status"][language]}
            </strong>
            : {status}
          </div>
        </div>
      </div>
      {imageFileName ? (
        <div className="pli-image">
          <img
            alt="PNUD and BID Cover"
            src={require("./../../../images/dashboard/"+imageFileName)}
            className="pnud-section-image"
          />
        </div>
      ) : null}
    </div>
  );
}
